import { Action, createReducer, on } from '@ngrx/store';
import { LoadStatus } from '../../load-status';
import {
    loadPwaPushNotificationSettingsSuccess,
    loadPwaPushNotificationSettingsError,
    savePwaPushNotificationSettings,
} from '../actions/pwa-push-notification.actions';
import { initialPwaPushNotificationState, PwaPushNotificationState } from '../pwa-push-notification.state';

export function updateSettingsAndSetStatusToLoaded(
    state: Readonly<PwaPushNotificationState>,
    { settings }: Pick<PwaPushNotificationState, 'settings'>,
): Readonly<PwaPushNotificationState> {
    return { ...state, settings, status: LoadStatus.Loaded };
}

export function setErrorInState(state: Readonly<PwaPushNotificationState>): Readonly<PwaPushNotificationState> {
    return { ...state, status: LoadStatus.Error };
}

const createPwaPushNotificationReducer = createReducer(
    initialPwaPushNotificationState,
    on(loadPwaPushNotificationSettingsSuccess, savePwaPushNotificationSettings, updateSettingsAndSetStatusToLoaded),
    on(loadPwaPushNotificationSettingsError, setErrorInState),
);

export function pwaPushNotificationReducer(
    state: Readonly<PwaPushNotificationState> | undefined,
    action: Action,
): Readonly<PwaPushNotificationState> {
    return createPwaPushNotificationReducer(state, action);
}
